import React, { useEffect, useState, useRef } from "react";
import "../../../../src/feature/incidents/cases/addCaseList.scss";
import { Grid } from "@mui/material";
import { API_STATUS } from "../../../constant/constant";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import Cards from "../component/Cards";
import DatePicker from "../../../library/custom/datePicker/DatePicker";
import {
  getCurrentDate,
  getDateWithDay,
  getFormatedDate,
  downloadExcel,
  downloadPDF,
  useInfiniteScroll,
} from "../../../utils/helper";
import { Popover } from "@mui/material";
import commonImages from "../../../assets";
import "./reportCrential.scss";
import Table from "../../../library/custom/table/table";

export default function ReportCredentialList({
  getLookupCredentialReportData,
  getLookupCredentialReports,
  credentialTabId,
  groupId,
  PAGE_SIZES,
  namess,
  location,
  data,
  setData,
  page,
  setPage,
  setDays,
  days,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  const credentialTabIdRef = useRef(credentialTabId);
  const startDateRef = useRef(startDate);
  const endDateRef = useRef(endDate);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [hasMoreData, setHasMoreData] = useState(true);
  const tableRef = useInfiniteScroll(
    () => fetchData(page + 1),
    [page],
    hasMoreData,
  );
  const [sortColumn, setSortColumn] = useState();
  const [sortDirection, setSortDirection] = useState("asc");
  useEffect(() => {
    startDateRef.current = startDate;
  }, [startDate]);

  useEffect(() => {
    endDateRef.current = endDate;
  }, [endDate]);

  useEffect(() => {
    credentialTabIdRef.current = credentialTabId;
  }, [credentialTabId]);

  const fetchMoreData = async (pageNumber) => {
    try {
      if (credentialTabId >= 0) {
        const response = await getLookupCredentialReports(
          groupId,
          credentialTabIdRef.current,
          getFormatedDate(startDateRef.current),
          getFormatedDate(endDateRef.current),
          0, //divistion
          pageNumber,
        );
        return response?.data || [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };
  const fetchData = async (pageNumber) => {
    const moreData = await fetchMoreData(pageNumber);

    if (!moreData || moreData.length === 0) {
      setHasMoreData(false); // No more data
      return;
    }

    setPage(pageNumber);
    setData((prevData) => [...prevData, ...moreData]);
  };

  useEffect(() => {
    setData([]);
  }, []);
  useEffect(() => {
    if (
      getLookupCredentialReportData?.data?.result?.credentialData &&
      getLookupCredentialReportData?.status === API_STATUS.SUCCESS
    ) {
      setData((prevData) => [
        ...prevData,
        ...getLookupCredentialReportData?.data?.result?.credentialData,
      ]);
    }
  }, [getLookupCredentialReportData?.data?.result?.credentialData]);
  useEffect(() => {
    if (location?.state?.timePeriod == 5)
      setDays({
        key: 12,
        value: "Custom",
      });
  }, [location]);
  const cardOnClick = (value) => {
    setData([]);

    if (days.key === value.key) {
      // custom date
      setDays("");
      setStartDate(null);
      setEndDate(null);
    } else {
      if (value.key !== 12) {
        let dateObj = getDateWithDay(value.key);

        setStartDate(dateObj.getCurrentDate);
        setEndDate(dateObj.futureData);
      } else if (value.key === 12) {
        let dateObj = getDateWithDay(value.key);
        getLookupCredentialReports(
          groupId,
          credentialTabId,
          startDate,
          endDate,
          "",
          page,
        );
      }
      setDays(value);
    }
  };

  const onchangeStartdatePicker = (e) => {
    setStartDate(e);
  };

  const onchangeEnddatePicker = (e) => {
    setEndDate(e);
  };
  useEffect(() => {
    if (startDate && endDate) {
      setData([]);
      getLookupCredentialReports(
        groupId,
        credentialTabId,
        getFormatedDate(startDate),
        getFormatedDate(endDate),
        "",
        1,
      );
    }
  }, [startDate, endDate, days]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const rowsPdf = data?.map((asset, index) => [
    asset?.userName,
    asset?.credentialName,
    asset?.credentialNameId,
    asset?.passingDate,
    asset?.expirationDate,
    asset?.issuingBody,
  ]);
  const columnsDownload = [
    {
      id: "userName",
      label: `Name`,
      sortable: false,
      isSorted: false,

      // sortDirection,
    },

    {
      id: "credentialName",
      label: `Credential Name`,
      sortable: false,
      isSorted: false,
      // sortDirection,
    },
    {
      id: "credentialNameId",
      label: `Credential Number`,
      sortable: false,
      isSorted: false,
      // sortDirection,
    },
    {
      id: "passingDate",
      label: `Passing Date`,
      sortable: false,
      isSorted: false,
      // sortDirection,
    },
    {
      id: "expirationDate",
      label: `Expiration Date`,
      sortable: false,
      isSorted: false,
      // sortDirection,
    },
    {
      id: "issuingBody",
      label: `Issuing Body`,
      sortable: false,
      isSorted: false,
      // sortDirection,
    },
  ];

  const columns = [
    {
      id: "id",
      label: `ID`,
      sortable: true,
      isSorted: sortColumn === "id",
      sortDirection,
      className: "inc_case-id",
    },
    {
      id: "userName",
      label: `Name`,
      sortable: true,
      isSorted: sortColumn === "userName",
      sortDirection,
    },

    {
      id: "credentialName",
      label: `Credential Name`,
      sortable: true,
      isSorted: sortColumn === "credentialName",
      sortDirection,
    },
    {
      id: "credentialNameId",
      label: `Credential Number`,
      sortable: true,
      isSorted: sortColumn === "credentialNameId",
      sortDirection,
    },
    {
      id: "passingDate",
      label: `Passing Date`,
      sortable: true,
      isSorted: sortColumn === "passingDate",
      sortDirection,
      className: "inc_dateOfEntry",
    },
    {
      id: "expirationDate",
      label: `Expiration Date`,
      sortable: true,
      isSorted: sortColumn === "expirationDate",
      sortDirection,
      className: "inc_dateOfEntry",
    },
    {
      id: "issuingBody",
      label: `Issuing Body`,
      sortable: true,
      isSorted: sortColumn === "issuingBody",
      sortDirection,
    },
  ];

  const filterDays = [
    {
      key: 0,
      value: "Today",
    },
    {
      key: 7,
      value: "7 days",
    },
    {
      key: 14,
      value: "14 days",
    },
    {
      key: 30,
      value: "30 days",
    },
    {
      key: 12,
      value: "Custom",
    },
  ];

  const handleSort = (column) => {
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";
    setSortDirection(newDirection);
    setSortColumn(column);
    const sortedData = [...data].sort((a, b) => {
      if (a[column] < b[column]) return newDirection === "asc" ? -1 : 1;
      if (a[column] > b[column]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };
  const rows = data?.map((user, index) => (
    <tr className="row" key={index}>
      <td>{user?.id}</td>
      <td>{user?.userName}</td>
      <td>{user?.credentialName}</td>
      <td>{user?.credentialNameId}</td>
      <td>{user?.passingDate}</td>
      <td>{user?.expirationDate}</td>
      <td>{user?.issuingBody}</td>
    </tr>
  ));

  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Credential Reports</div>
        </div>
        <Grid item lg={8} xs={12} sm={12} md={8}>
          <FormLabels label={"Select Time Period"} />
          <Cards
            staticCardData={true}
            cardData={filterDays}
            selectedVehicleAccident={days}
            cardClickHandler={cardOnClick}
          />
        </Grid>

        {days?.value === "Custom" ? (
          <>
            <Grid item container mt={0} spacing={1}>
              <Grid item lg={4} xs={12} sm={12}>
                <FormLabels label={"Custom Time Period"} isRequired={false} />
              </Grid>
            </Grid>

            <Grid item container spacing={2} mb={2}>
              <Grid item lg={3} xs={12} sm={12} md={4}>
                <FormLabels label={"From"} isRequired={false} />
                <DatePicker
                  maxDateEnable={true}
                  value={startDate}
                  disabled={false}
                  onChangeHandler={(e) => onchangeStartdatePicker(e)}
                />
              </Grid>
              <Grid item lg={3} xs={12} sm={12} md={4}>
                <FormLabels label={"To"} isRequired={false} />

                <DatePicker
                  maxDateEnable={true}
                  minDate={startDate}
                  value={endDate}
                  disabled={false}
                  onChangeHandler={(e) => onchangeEnddatePicker(e)}
                />
              </Grid>
            </Grid>
          </>
        ) : null}

        <Grid mt={2}>
          <div className="grid_main_header two_grid">
            <div className="grid_heading_style">{namess}</div>
            <div className="credntialReporttopHeaderDrillRight">
              <div
                className="downloadBox"
                aria-describedby={id}
                variant="contained"
                onClick={handleClick}
              >
                <div className="downloadIcon">
                  <img src={commonImages?.downloadWhite} alt="Download" />
                </div>
                <div className="downloadText">Download Data</div>
              </div>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div className="downloadListBox">
                  <div className="downloadList">
                    <div className="downloads">
                      <div
                        className="downloadListIcon"
                        onClick={() =>
                          downloadPDF(
                            rowsPdf,
                            columnsDownload.map((col) => col.label),
                            "Credentials.pdf",
                          )
                        }
                      >
                        <img src={commonImages.pdfFill} alt="" />
                        <span>Download PDF</span>
                      </div>
                    </div>
                  </div>
                  <div className="downloadList">
                    <div className="downloads">
                      <div
                        className="downloadListIcon"
                        onClick={() =>
                          downloadExcel(
                            getLookupCredentialReportData?.data?.result
                              ?.credentialData ?? [],
                            "Credential.xlsx",
                          )
                        }
                      >
                        <img src={commonImages.excelDownload} alt="" />
                        <span>Download .xlsx</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Popover>
            </div>
          </div>

          <div className="customTableWrapper">
            <Table
              columns={columns}
              rows={rows}
              tableRef={tableRef}
              onSort={handleSort}
            />
          </div>
        </Grid>
      </section>
    </>
  );
}
